import { Component } from "react";
import * as config from "../../config";

interface VFProps {
  jwtToken: string | null;
}

type FunctionKey =
  | "/V2C/OEMSW/remoteservices/forgetinform/data-upload"
  | "/V2C/OEMSW/remoteservices/charge/data-upload"
  | "/V2C/OEMSW/remoteservices/electricsupply/data-upload"
  | "/V2C/OEMSW/remoteservices/remotecheck/data-upload"
  | "/V2C/OEMSW/remoteservices/guestdrivermonitor/data-upload"
  | "/V2C/OEMSW/remoteservices/alarm/data-upload"
  | "/V2C/OEMSW/remoteservices/remoteac/result";

class vehicleFunction extends Component<VFProps, any> {
  functionScenarioMap: Record<FunctionKey, string[]> = {
    "/V2C/OEMSW/remoteservices/forgetinform/data-upload": [
      "Driver Door Open and Unlocked",
      "Passenger Door Open and Unlocked",
      "RearLeft Door Open and Unlocked",
      "RearRight Door Open and Unlocked",
      "Trunk Open and Unlocked",
      "Hatch Open and Unlocked",
      "Driver Door Closed and Locked",
      "Passenger Door Closed and Locked",
      "RearLeft Door Closed and Locked",
      "RearRight Door Closed and Locked",
      "Trunk Closed and Locked",
      "Hatch Closed and Locked",
      "Driver Door Closed and Unlocked",
      "Passenger Door Closed and Unlocked",
      "RearLeft Door Closed and Unlocked",
      "RearRight Door Closed and Unlocked",
      "Trunk Closed and Unlocked",
      "Hatch Closed and Unlocked",
      "Driver, Passenger Door Open and Unlocked",
      "RearLeft, RearRight Door Open and Unlocked",
      "All Doors Open and Unlocked",
      "All Doors Closed and Locked",
      "All Doors Closed and Unlocked",
      "Hood Open",
      "Hood Closed",
      "Sunroof Open",
      "Sunroof Closed",
      "ChargeLid Left Open",
      "ChargeLid Left Closed",
      "ChargeLid Right Open",
      "ChargeLid Right Closed",
      "Driver Window Full Open (100%)",
      "Passenger Window Full Open (100%)",
      "RearLeft Window Full Open (100%)",
      "RearRight Window Full Open (100%)",
      "Back Window Full Open (100%)",
      "Driver Window Partial Open (40%)",
      "Passenger Window Partial Open (50%)",
      "RearLeft Window Partial Open (60%)",
      "RearRight Window Partial Open (70%)",
      "Back Window Partial Open (80%)",
      "Driver Window Full Closed (0%)",
      "Passenger Window Full Closed (0%)",
      "RearLeft Window Full Closed (0%)",
      "RearRight Window Full Closed (0%)",
      "Back Window Full Closed (0%)",
      "Driver, Passenger Window Full Open (100%)",
      "RearLeft, RearRight Window Partial Open (40%)",
      "All Windows Full Open (100%)",
      "All Windows Full Closed (0%)",
      "NoRequest (000b)",
      "PossibilityChildByDoorLogic (001b)",
      "ChildBySensor (010b)",
      "ChildBySensorParkingState1 (011b)",
      "ChildBySensorParkingState2 (100b)",
      "ChildBySensorParkingState3 (101b)",
      "Cabin Awareness",
    ],
    "/V2C/OEMSW/remoteservices/charge/data-upload": [
      "EV - Charge Start",
      "EV - Charge Stop",
      "PHEV - Charge Start",
      "PHEV - Charge Stop",
      "EV - Not Plugged-In, 100% Charge Level, 500 miles Range, 400 miles Range with AC",
      "EV - Not Plugged-In, 70% Charge Level, 350 miles Range, 280 miles Range with AC",
      "EV - Not Plugged-In, 10% Charge Level, 50 miles Range, 40 miles Range with AC",
      "EV - Plugged-In, 100% Charge Level, 500 miles Range, 400 miles Range with AC",
      "EV - Plugged-In, 70% Charge Level, 350 miles Range, 280 miles Range with AC",
      "EV - Plugged-In, 10% Charge Level, 50 miles Range, 40 miles Range with AC",
      "EV - Charging, 100% Charge Level, 500 miles Range, 400 miles Range with AC",
      "EV - Charging, 70% Charge Level, 350 miles Range, 280 miles Range with AC, 30 mins, 20 mins Charge Time Est",
      "EV - Charging, 10% Charge Level, 50 miles Range, 40 miles Range with AC, 90 mins, 80 mins Charge Time Est",
      "PHEV - Not Plugged-In, 100% Charge Level, 500 miles Range, 400 miles Range with AC, 400 miles HV Range, 100 miles EV Range",
      "PHEV - Not Plugged-In, 70% Charge Level, 350 miles Range, 280 miles Range with AC, 250 miles HV Range, 100 miles EV Range",
      "PHEV - Not Plugged-In, 10% Charge Level, 50 miles Range, 40 miles Range with AC, 30 miles HV Range, 20 miles EV Range",
      "PHEV - Plugged-In, 100% Charge Level, 500 miles Range, 400 miles Range with AC, 400 miles HV Range, 100 miles EV Range",
      "PHEV - Plugged-In, 70% Charge Level, 350 miles Range, 280 miles Range with AC, 250 miles HV Range, 100 miles EV Range",
      "PHEV - Plugged-In, 10% Charge Level, 50 miles Range, 40 miles Range with AC, 30 miles HV Range, 20 miles EV Range",
      "PHEV - Charging, 100% Charge Level, 500 miles Range, 400 miles Range with AC, 400 miles HV Range, 100 miles EV Range",
      "PHEV - Charging, 70% Charge Level, 350 miles Range, 280 miles Range with AC, 30 mins Charge Time Est, 250 miles HV Range, 100 miles EV Range",
      "PHEV - Charging, 10% Charge Level, 50 miles Range, 40 miles Range with AC, 90 mins Charge Time Est, 30 miles HV Range, 20 miles EV Range",
      "EV / PHEV - Battery Charging Target Limit, 100% Charge Level",
      "EV / PHEV - Battery Charging Target Limit, 70% Charge Level",
      "EV / PHEV - Battery Charging Target Limit, 40% Charge Level",
      "EV / PHEV - DC QuickCharge PowerLimit, 1 (Max) Charge Level",
      "EV / PHEV - DC QuickCharge PowerLimit, 350KW Charge Level",
      "EV / PHEV - DC QuickCharge PowerLimit, 100KW Charge Level",
      //"EV / PHEV - DCQuickChargePowerLimit0NoSettingChargeLevel",
      "EV / PHEV - AC Charge Current, 127A (Max) Charge Level",
      "EV / PHEV - AC Charge Current, 32A Charge Level",
      "EV / PHEV - AC Charge Current, 16A Charge Level",
      "EV / PHEV - AC Charge Current, 8A Charge Level",
      //"EV / PHEV - AC Charge Current, 0 (No Setting) Charge Level",
      //"EV / PHEV - No Schedule",
      "EV / PHEV - Single Schedule Active: Schedule 1, Active",
      "EV / PHEV - Multiple Schedules Active: Schedule 1, Active",
      "EV / PHEV - Multiple Schedules Active: Schedule 2, Active",
      "EV / PHEV - Multiple Schedules Active: Schedule 3, Inactive",
      "EV / PHEV - Multiple Schedules Active: Schedule 4, Active",
    ],
    "/V2C/OEMSW/remoteservices/electricsupply/data-upload": [
      "EV / PHEV - MinimumElectricSupply, 50% Charge Level, 250 miles Range, 200 miles, Range with AC, 50 mins Charge Time Est",
      "EV / PHEV - MinimumElectricSupply, 30% Charge Level, 150 miles Range, 120 miles, Range with AC, 70 mins Charge Time Est",
      "EV / PHEV - MinimumElectricSupply, 0% (Min) Charge Level, 500 miles Range, 400 miles, Range with AC",
      "EV vehicle Plgsts ElectricSupplyStandby PwspltB 60 mins PwspltG No SocDsp 100% Pieve06 No",
      "EV vehicle Plgsts ElectricSupplyElectric PwspltB 30 mins PwspltG No SocDsp 75% Pieve06 No",
      "EV vehicle Plgsts ElectricSupplyStop PwspltB 10 mins No PwspltG 50% SocDsp Pieve06 No",
    ],
    "/V2C/OEMSW/remoteservices/remotecheck/data-upload": [
      "Odometer 123456",
      "Odometer	0 miles",
      "Odometer	0 KM",
      "Odometer	999,999 miles",
      "Odometer	999,999 KM",
      "Odometer	10,000,000 KM",
      "Fuel Gauge Full (100%)",
      "Fuel Gauge Partial (70%)",
      "Fuel Gauge Partial (10%)",
      "Fuel Gauge Empty (0%)",
      "Fuel Gauge, Range Full (100%), 500 miles",
      "Fuel Gauge, Range Partial (70%), 350 miles",
      "Fuel Gauge, Range Partial (31%), 155 miles",
      "Fuel Gauge, Range Partial (10%), 50 miles",
      "Fuel Gauge, Range Empty (0%), 0 miles",
      "Driver Tire Pressure Normal",
      "Passenger Tire Pressure Normal",
      "RearLeft Tire Pressure Normal",
      "RearRight Tire Pressure Normal",
      "Spare Tire Pressure Normal",
      "Driver Tire Pressure Low",
      "Passenger Tire Pressure Low",
      "RearLeft Tire Pressure Low",
      "RearRight Tire Pressure Low",
      "Spare Tire Pressure Low",
      "Driver, Passenger Low, Normal",
      "RearLeft, RearRight Tire Pressure Low, Normal",
      "Driver, Passenger Tire Pressure",
      "RearLeft, RearRight Tire Pressure",
      "All Tires Normal",
      "All Tires Low",
      "All Tires",
    ],
    "/V2C/OEMSW/remoteservices/guestdrivermonitor/data-upload": [
      "Automatic Brake Pbatrgr NoRequest",
      "Automatic Brake Pbatrgr Pba1Request",
      "Automatic Brake Pbatrgr Pba2Request",
      "Automatic Brake Pbatrgr Pba3Request",
      "Impact Recrnon ImpactDetection",
      "Impact Recrnon NoImpactDetection",
      "Impact Recrnoff ImpactDetection",
      "Impact Recrnoff NoImpactDetection",
      "Seatbelt DbklMet SeatbeltFastened",
      "Seatbelt DbklMet SeatbeltNotFastened",
      "Total Miles Driven AsDt 30 miles",
      "Total Miles Driven AsDt 50 miles",
      "Total Miles Driven AsDt 60 miles",
      "Total Time Driven AsTm 60 min",
      "Total Time Driven AsTm 120 min",
      "Total Time Driven AsTm 180 min",
    ],
    "/V2C/OEMSW/remoteservices/alarm/data-upload": [
      "Security Control Signal Salr DisarmedState",
      "Security Control Signal Salr ArmingPreparationState",
      "Security Control Signal Salr ArmedState",
      "Security Control Signal Salr AlarmSoundingState",
      "Security Control Signal Salr PanicSoundingState",
      "Security Control Signal Salr PanicNotSoundingState",
      "Alarm Reason AareB Door",
      "Alarm Reason AareB Trunk",
      "Alarm Reason AareB Hood",
      "Alarm Reason AareB BatteryDetached",
      "Alarm Reason AareB GlassCracked",
      "Alarm Reason AareB Intrusion",
      "Alarm Reason AareB Gradient",
      "Alarm Reason AareB IgOn",
      "Alarm Reason AareB None",
      "Alarm Reason AareB Undefined",
    ],
    "/V2C/OEMSW/remoteservices/remoteac/result": ["Success DA", "Failure D3"],
  };
  constructor(props: any) {
    super(props);
    this.state = {
      selectedFunction: "" as FunctionKey | "",
      selectedScenario: "",
      notification: "",
      scenarioOptions: [] as string[],
    };
  }

  handleFunctionChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedFunction = event.target.value as FunctionKey;

    const scenarioOptions = this.functionScenarioMap[selectedFunction] || [];

    this.setState({
      selectedFunction,
      selectedScenario: "",
      scenarioOptions,
    });
  };

  handleScenarioChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    this.setState({ selectedScenario: event.target.value });
  };

  handleTrigger = () => {
    const { selectedFunction, selectedScenario } = this.state;
    const queryParams1 = new URLSearchParams(window.location.search);
    const deviceid1 = queryParams1.get("deviceid");

    if (!selectedFunction || !selectedScenario) {
      this.setState({
        notification: "Error: Please select both function and scenario",
      });
      return;
    }

    fetch(config.rootUrl + "/v1/simulator/vehiclestatusdatauploadtrigger", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-api-key": config.apiKey,
        Authorization: "Bearer " + this.props.jwtToken,
      },
      body: JSON.stringify({
        functiontopic: selectedFunction,
        scenario: selectedScenario,
        vin: deviceid1,
        environment: localStorage.getItem("selectedEnv")
      }),
    })
      .then((response) => {
        if (response.ok) {
          this.setState({ notification: "Data uploaded successfully" });
        } else {
          throw new Error("Network response was not ok");
        }
      })
      .catch((error) => {
        console.error("There was a problem with the upload:", error);
        this.setState({
          notification:
            "Error: There was a problem with the upload. Please check if vin is active.",
        });
      })
      .finally(() => {
        setTimeout(() => {
          this.setState({ notification: "" });
        }, 3000);
      });
  };

  render() {
    const { notification, scenarioOptions, selectedFunction } = this.state;
    return (
      <div style={{ maxWidth: "80%", margin: "0 auto", padding: "16px" }}>
        <h1 style={{ fontSize: "24px", marginBottom: "16px" }}>
          Vehicle Status Data Upload Page
        </h1>
        {notification && (
          <div
            style={{
              backgroundColor: notification.includes("Error")
                ? "#dc3545"
                : "#28a745",
              color: "#fff",
              padding: "10px",
              borderRadius: "4px",
              marginBottom: "20px",
            }}
          >
            {notification}
          </div>
        )}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "16px",
          }}
        >
          <div style={{ flex: 0.6, marginRight: "10px" }}>
            <label
              htmlFor="topic"
              style={{
                display: "block",
                marginBottom: "10px",
                fontSize: "14px",
              }}
            >
              Select Vehicle Status Function:
            </label>
            <select
              id="topic"
              style={{
                width: "100%",
                padding: "8px",
                fontSize: "12px",
                border: "1px solid #ccc",
                borderRadius: "4px",
                backgroundColor: "#fff",
              }}
              onChange={this.handleFunctionChange}
              value={selectedFunction}
            >
              <option value="" disabled selected>
                Select Vehicle Status Function
              </option>
              <option value="/V2C/OEMSW/remoteservices/digitalkey/data-upload">
                Digital Key
              </option>
              <option value="/V2C/OEMSW/remoteservices/electricsupply/data-upload">
                Electric Supply
              </option>
              <option value="/V2C/OEMSW/remoteservices/forgetinform/data-upload">
                Forget Inform
              </option>
              <option value="/V2C/OEMSW/remoteservices/optimumcharge/data-upload">
                Optimum Charge
              </option>
              <option value="/V2C/OEMSW/remoteservices/charge/data-upload">
                Remote Charge
              </option>
              <option value="/V2C/OEMSW/remoteservices/remoteac/data-upload">
                Remote Climate
              </option>
              <option value="/V2C/OEMSW/remoteservices/remotecheck/data-upload">
                Remote Confirm
              </option>
              <option value="/V2C/OEMSW/remoteservices/solarcharge/data-upload">
                Solar Charge
              </option>
              <option value="/V2C/OEMSW/remoteservices/guestdrivermonitor/data-upload">
                Guest Driver Monitor
              </option>
              <option value="/V2C/OEMSW/remoteservices/alarm/data-upload">
                Alarm Notification
              </option>
              <option value="/V2C/OEMSW/remoteservices/remoteac/result">
                Remote Climate - Request Result Notification (00DA)
              </option>
            </select>
          </div>
          <div style={{ flex: 1.4, marginLeft: "10px" }}>
            <label
              htmlFor="scenarioId"
              style={{
                display: "block",
                marginBottom: "10px",
                fontSize: "14px",
              }}
            >
              Select Scenario:
            </label>
            <select
              id="scenario"
              autoComplete="off"
              style={{
                width: "100%",
                padding: "8px",
                fontSize: "12px",
                border: "1px solid #ccc",
                borderRadius: "4px",
                backgroundColor: "#fff",
              }}
              onChange={this.handleScenarioChange}
              value={this.state.selectedScenario}
              disabled={!selectedFunction}
            >
              <option value="" disabled>
                Select Scenario
              </option>
              {scenarioOptions.map((option: string) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>
          </div>
        </div>

        <hr />
        <button
          style={{
            padding: "8px 16px",
            fontSize: "12px",
            border: "none",
            borderRadius: "4px",
            backgroundColor: "#007bff",
            color: "#fff",
            cursor: "pointer",
          }}
          onClick={this.handleTrigger}
        >
          Trigger
        </button>
      </div>
    );
  }
}

export default vehicleFunction;
